'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Expiry date used for adding a card
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _propValidators = require('prop-validators');

var _dateUtils = require('./date-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLES = {
	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
};

var Expiry = _react2.default.createClass({
	displayName: 'Expiry',

	propTypes: {
		cardSpec: _propValidators.cardSpecPropType,
		label: _react.PropTypes.string.isRequired,
		helpText: _react.PropTypes.string,
		errorMessage: _react.PropTypes.string,
		handleChangeDate: _react.PropTypes.func.isRequired,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func,
		dir: _react.PropTypes.string
	},

	getDefaultProps: function getDefaultProps() {
		return {
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {}
		};
	},
	getInitialState: function getInitialState() {
		return {
			showIsRequiredError: false,
			lastCharacterIsSlash: false
		};
	},


	/**
  * Handle changing expiry date
  * Use the getFormattedExpirationDate util to format the date
  * @param {String} date - expiry date
  * @return {String} expiry - the formatted date
  */
	handleChangeDate: function handleChangeDate(date) {

		// if the new date is two digits and the previous date ended in a slash, we
		// should not add a slash when we format the date
		var shouldRemoveTrailingSlash = date.length === 2 && this.state.lastCharacterIsSlash;

		var expiry = (0, _dateUtils.getFormattedExpirationDate)(date, { shouldRemoveTrailingSlash: shouldRemoveTrailingSlash });
		this.handleCheckForValue(date);
		this.props.handleChangeDate(expiry);

		this.setState({ lastCharacterIsSlash: expiry.slice(-1) === '/' });

		return expiry;
	},


	/**
  * Check for a date value
  * If the field is required, we should show that this field needs a value
  * @param {String} date - expiry date
  */
	handleCheckForValue: function handleCheckForValue(date) {
		var _props$cardSpec$field = this.props.cardSpec.fields.expirationDate.required;
		var required = _props$cardSpec$field === undefined ? false : _props$cardSpec$field;

		this.setState({ showIsRequiredError: required && !date });
	},


	/**
  * Call parent's handleFocus
  * @param {String} date - expiry date
  */
	handleFocus: function handleFocus(date) {
		this.props.handleFocus(date);
	},


	/**
  * Check for a date value and call parent's handleBlur
  * @param {String} date - expiry date
  */
	handleBlur: function handleBlur(date) {
		this.handleCheckForValue(date);
		this.props.handleBlur(date);
	},
	render: function render() {
		var expirySpecs = this.props.cardSpec.fields.expirationDate;
		var errorMessage = this.props.errorMessage;

		var errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}

		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)({
					'vx_has-error-with-message': errorMessage,
					'vx_has-error': !errorMessage && this.state.showIsRequiredError
				}), style: { margin: '10px 0 0', position: 'relative' } },
			_react2.default.createElement(_reactTextInput2.default, { type: 'tel',
				id: 'expiry',
				name: 'expiry',
				className: 'vx_form-control vx_form-control_complex',
				label: this.props.label,
				maxlength: expirySpecs.maxlength,
				pattern: expirySpecs.pattern,
				required: expirySpecs.required,
				helpText: this.props.helpText,
				handleChange: this.handleChangeDate,
				handleFocus: this.handleFocus,
				handleBlur: this.handleBlur,
				dir: this.props.dir }),
			_react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)({
						'vx_form-control-message': errorMessage
					}), style: _extends({}, STYLES.errorMessage, { errorStyles: errorStyles }) },
				errorMessage
			)
		);
	}
});

exports.default = Expiry;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react-expiry-date/dist/index.js
// module id = 385
// module chunks = 6